import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS,I_COMMON_DELETE_PARAMS} from './_base';

import I_SKILL from '../interfaces/I_SKILLS';
import {
  getSkillsResponse,
  postSkillResponse,
  deleteSkillResponse,
  putSkillResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- SKILLS
// ---------------------------------

const logger = LoggerService.getInstance();

/**
 * Récupère la liste des compétences
 * @param obj
 * @returns
 */
const getList = async ({accessToken,refreshToken,dispatch,state}:I_COMMON_GET_ALL_PARAMS):Promise<I_SKILL[]> => {
  logger.debug('ApiServices - getSkills - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getSkillsResponse({accessToken:usedAccessToken});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getSkills - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_SKILL[] = await response.json();
  logger.debug('ApiServices - getSkills - ok, returned body',body);
  return body;
};

interface I_CREATE_SKILL_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  name: string,
  description: string,
  parent: number,
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Crée une compétence
 * @param param0
 * @returns
 */
const create = async ({accessToken,refreshToken,name,description,parent,dispatch,state}:I_CREATE_SKILL_PARAMS):Promise<string> => {
  logger.debug('ApiServices - createSkill - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (!description) {
    description = '';
  }
  if (
    !name || name === null || name.trim() === '' ||
    description === undefined || description === null || // description pas obligatoire
    parent === undefined || parent === null) {
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing name, description or parentID',
      errorMessage: 'Missing name, description or parentID to post skill',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return postSkillResponse({accessToken:usedAccessToken,name,description,parent});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - createSkill - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - createSkill - ok, returned body',body);
  logger.info(...formatInfo('Skill created!'));
  return body;
};

/**
 * Supprime une compétence
 * @param param0
 * @returns
 */
const remove = async ({accessToken,refreshToken,id,dispatch,state}:I_COMMON_DELETE_PARAMS):Promise<string> => {
  logger.debug('ApiServices - deleteSkill - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return deleteSkillResponse({accessToken:usedAccessToken,id});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - deleteSkill - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - deleteSkill - ok, returned body',body);
  logger.info(...formatInfo('Skill deleted!'));
  return body;
};

interface I_PUT_SKILL_PARAMS {
  accessToken?: string,
  refreshToken?: string,
  id: number,
  name: string,
  description: string,
  parent: number;
  dispatch: any; // on a besoin du dispatch pour store les tokens en cas de refresh
  state: any; // on a besoin du state pour comparer les tokens en cas de 401
}
/**
 * Modifie une compétence
 * @param param0
 * @returns
 */
const update = async ({accessToken,refreshToken,id,name,description,parent,dispatch,state}:I_PUT_SKILL_PARAMS):Promise<string> => {
  logger.debug('ApiServices - updateSkill - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // pre-verification qu'on a bien des valeurs obligatoires, sinon sert a rien de faire la requete
  if (
    id === undefined || id === null ||
    !name || name === null || name.trim() === '' ||
    description === undefined || description === null) { // description pas obligatoire
    const error = {
      error: true,
      errorCode: 1000,
      errorText: 'Missing id, name, description or parentID',
      errorMessage: 'Missing id, name, description or parentID to put skill',
    };
    return Promise.reject(error);
  }
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return putSkillResponse({accessToken:usedAccessToken,id,name,description,parent});
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - updateSkill - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:string = await response.text();
  logger.debug('ApiServices - updateSkill - ok, returned body',body);
  logger.info(...formatInfo('Skill updated!'));
  return body;
};



const skillsServices = {
  getList,
  create,
  remove,
  update,
};

export default skillsServices;
